import moment from 'moment';

export const moment2date = (value) => {
  if (!value) {
    return '';
  }

  return value.format('dddd DD MMMM YYYY');
};


export const moment2datetime = (value) => {
  if (!value) {
    return '';
  }

  return value.format('DD MMMM YYYY, hh:mm');
};

export const moment2format = (value, format) => {
  if (!value) {
    return '';
  }

  return value.format(format);
};

export const text2moment = (value) => {
  if (!value) {
    return null;
  }

  return moment(value);
};

export const color2text = (value) => {
  switch (value) {
    case 'red':
      return 'Rouge';

    case 'rose':
      return 'Rosé';

    case 'white':
      return 'Blanc';
  }

  return value;
};

export const contract2text = (value) => {
  switch (value) {
    case 'location':
      return 'Location';

    case 'depot':
      return 'Dépôt';

    case 'sale':
      return 'Vente';
  }

  return value;
};

export const toFixed = (value, precision) => {
  if (Number.isFinite(value) && !Number.isInteger(value)) {
    return value.toFixed(precision);
  }

  return value;
};

export const periodToChartLabel = (period) => {
  switch (period) {
    case 'day':
      return 'Heures de la journée';
    case 'week':
      return 'Jour de la semaine';
    case 'month':
      return 'Jour du mois';
    case 'year':
      return 'Mois de l\'année';
  }

  return period;
};

export const dateTimeToChartLabel = (value, period) => {
  const dt = moment(value);

  switch (period) {
    case 'day':
      return dt.format('HH');
    case 'week':
      return dt.format('dddd');
    case 'month':
      return dt.format('DD');
    case 'year':
      return dt.format('MMMM');
  }

  return dt.toISOString();
};
